export const ALLOWED_TEXT_STYLES = ['muted', 'amplified', 'inverse'] as const
export const ALLOWED_TEXT_TYPES = ['title', 'subtitle'] as const
export const ALLOWED_TEXT_THEMES = ['light', 'dark'] as const

export const ALLOWED_BUTTON_TYPES = ['normal'] as const
export const ALLOWED_BUTTON_STYLES = ['filled'] as const
export const ALLOWED_BUTTON_THEMES = ['primary', 'amplified'] as const
